import React, { FC, memo } from 'react'

import { ErrPageContainer, ErrPageCode } from '../styles'

const ErrorNotFoundRaw: FC = () => {
  return (
    <ErrPageContainer>
      <ErrPageCode>404</ErrPageCode>
    </ErrPageContainer>
  )
}

export const ErrorNotFound = memo(ErrorNotFoundRaw)
